module.exports = __webpack_public_path__ + "static/media/3.2fe19494.jpg";